import React from 'react'
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material'

export interface Degree {
  id: number
  code: string
  description: string
}

export const degreeOptions = new Map([
  [1010, { id: 1010, code: 'Assc. Deg.', description: "Associate's Degree" }],
  [1001, { id: 1001, code: 'Bach. Deg.', description: "Bachelor's Degree" }],
  [1002, { id: 1002, code: 'Mast. Deg.', description: "Master's Degree" }],
  [1027, { id: 1027, code: 'Doct. Deg.', description: "Doctorate's Degree" }],
  [999, { id: 999, code: 'Att.', description: 'Attended' }],
  [2, { id: 2, code: 'A.A.', description: 'Associate in Arts' }],
  [4, { id: 4, code: 'A.A.S.', description: 'Associate of Applied Science' }],
  [1006, { id: 1006, code: 'A.B.', description: 'Bachelor of Arts (Artium Baccalaureus)' }],
  [1003, { id: 1003, code: 'A.S.N.', description: 'Associate of Science in Nursing' }],
  [35, { id: 35, code: 'A.D.', description: 'Associate Degree' }],
  [75, { id: 75, code: 'A.M.T.', description: 'Master of Arts in Training' }],
  [1, { id: 1, code: 'Ae.E.', description: 'Aeronautical Engineer' }],
  [1011, { id: 1011, code: 'A.S.', description: 'Associate of Science' }],
  [7, { id: 7, code: 'B.A.', description: 'Bachelor of Arts' }],
  [108, { id: 108, code: 'B.A.E.', description: 'Bachelor of Aeronautical Engineering' }],
  [109, { id: 109, code: 'B.A.E.', description: 'Bachelor of Agricultural Engineering' }],
  [110, { id: 110, code: 'B.A.E.', description: 'Bachelor of Architectural Engineering' }],
  [9, { id: 9, code: 'B.A.E.', description: 'Bachelor of Arts in Education' }],
  [107, { id: 107, code: 'B.Accty', description: 'Bachelor of Accountancy' }],
  [5, { id: 5, code: 'B.Ag.', description: 'Bachelor of Agriculture' }],
  [6, { id: 6, code: 'B.Arch.', description: 'Bachelor of Architecture' }],
  [10, { id: 10, code: 'B.B.A.', description: 'Bachelor of Business Administration' }],
  [12, { id: 12, code: 'B.C.E.', description: 'Bachelor of Christian Education' }],
  [130, { id: 130, code: 'B.C.E.', description: 'Bachelor of Civil Engineering' }],
  [11, { id: 11, code: 'B.Ch.E.', description: 'Bachelor of Chemical Engineering' }],
  [1016, { id: 1016, code: 'B.C.J', description: 'Bachelor of Criminal Justice' }],
  [111, { id: 111, code: 'B.CL', description: 'Bachelor of Civil Law' }],
  [112, { id: 112, code: 'B.Comm', description: 'Bachelor of Commerce' }],
  [113, { id: 113, code: 'B.CS.', description: 'Bachelor of Computer Science' }],
  [13, { id: 13, code: 'B.D.', description: 'Bachelor of Divinity' }],
  [14, { id: 14, code: 'B.E.', description: 'Bachelor of Education' }],
  [114, { id: 114, code: 'B.E.', description: 'Bachelor of Engineering' }],
  [28, { id: 28, code: 'B.E.D.', description: 'Bachelors Degree in Education' }],
  [15, { id: 15, code: 'B.E.E.', description: 'Bachelor of Electrical Engineering' }],
  [17, { id: 17, code: 'B.F.', description: 'Bachelor of Forestry' }],
  [16, { id: 16, code: 'B.F.A.', description: 'Bachelor of Fine Arts' }],
  [18, { id: 18, code: 'B.J.', description: 'Bachelor of Journalism' }],
  [115, { id: 115, code: 'B.L.I.S.', description: 'Bachelor of Library and Information Science' }],
  [20, { id: 20, code: 'B.L.S.', description: 'Bachelor of Liberal Studies' }],
  [21, { id: 21, code: 'B.Litt.', description: 'Bachelor of Literature' }],
  [22, { id: 22, code: 'B.M.', description: 'Bachelor of Medicine' }],
  [116, { id: 116, code: 'B.M.', description: 'Bachelor of Music' }],
  [117, { id: 117, code: 'B.Math', description: 'Bachelor of Mathematics' }],
  [23, { id: 23, code: 'B.Mus.', description: 'Bachelor of Music' }],
  [24, { id: 24, code: 'B.N.', description: 'Bachelor of Nursing' }],
  [118, { id: 118, code: 'B.PE', description: 'Bachelor of Physical Education' }],
  [25, { id: 25, code: 'B.Pharm.', description: 'Bachelor of Pharmacy' }],
  [27, { id: 27, code: 'B.R.E.', description: 'Bachelor of Religious Education' }],
  [31, { id: 31, code: 'B.S.', description: 'Bachelor of Science' }],
  [32, { id: 32, code: 'B.S.E.', description: 'Bachelor of Science in Engineering' }],
  [33, { id: 33, code: 'B.S.Ed.', description: 'Bachelor of Science in Education' }],
  [34, { id: 34, code: 'B.S.N.', description: 'Bachelor of Science in Nursing' }],
  [38, { id: 38, code: 'C.E.', description: 'Civil Engineer' }],
  [37, { id: 37, code: 'Chem.E.', description: 'Chemical Engineer' }],
  [39, { id: 39, code: 'D.B.A.', description: 'Doctor of Business Administration' }],
  [42, { id: 42, code: 'D.D.', description: 'Doctor of Divinity' }],
  [119, { id: 119, code: 'D.D.S.', description: 'Doctor of Dental Science' }],
  [41, { id: 41, code: 'D.D.S.', description: 'Doctor of Dental Surgery' }],
  [1025, { id: 1025, code: 'D.Eng.', description: 'Doctor of Engineering' }],
  [1022, { id: 1022, code: 'D.H.A.', description: 'Doctor of Health Administration' }],
  [1023, { id: 1023, code: 'D.H.S.', description: 'Doctorate in Health Sciences' }],
  [1019, { id: 1019, code: 'D.LP.', description: 'Doctorate in Law and Public Policy' }],
  [48, { id: 48, code: 'D.L.S.', description: 'Doctor of Library Science' }],
  [1020, { id: 1020, code: 'D.M.', description: 'Doctorate of Management' }],
  [40, { id: 40, code: 'D.M.D.', description: 'Doctor of Dental Medicine' }],
  [49, { id: 49, code: 'D.M.S.', description: 'Doctor of Medical Science' }],
  [1014, { id: 1014, code: 'D.Min.', description: 'Doctor of Ministry' }],
  [1015, { id: 1015, code: 'D.N.P.', description: 'Doctor of Nursing Practice' }],
  [52, { id: 52, code: 'D.O.', description: 'Doctor of Osteopathy' }],
  [55, { id: 55, code: 'D.P.A.', description: 'Doctor of Public Administration' }],
  [56, { id: 56, code: 'D.P.H.', description: 'Doctor of Public Health' }],
  [1026, { id: 1026, code: 'D.P.M.', description: 'Doctor of Podiatric Medicine' }],
  [57, { id: 57, code: 'D.R.E.', description: 'Doctor of Religious Education' }],
  [62, { id: 62, code: 'D.S.W.', description: 'Doctor of Social Welfare' }],
  [121, { id: 121, code: 'D.S.W.', description: 'Doctor of Social Work' }],
  [60, { id: 60, code: 'D.Sc.', description: 'Doctor of Science' }],
  [65, { id: 65, code: 'D.V.M.', description: 'Doctor of Veterinary Medicine' }],
  [67, { id: 67, code: 'E.E.', description: 'Electrical Engineer' }],
  [69, { id: 69, code: 'E.M.', description: 'Engineer of Mines' }],
  [122, { id: 122, code: 'E.M.', description: 'Mining Engineer' }],
  [68, { id: 68, code: 'E.Met.', description: 'Engineer of Metallurgy' }],
  [43, { id: 43, code: 'Ed.D.', description: 'Doctor of Education' }],
  [66, { id: 66, code: 'Ed.S.', description: 'Education Specialist' }],
  [70, { id: 70, code: 'I.E.', description: 'Industrial Engineer' }],
  [46, { id: 46, code: 'J.D.', description: 'Doctor of Jurisprudence' }],
  [63, { id: 63, code: 'J.S.D.', description: 'Doctor of the Science of Law' }],
  [44, { id: 44, code: 'L.H.D.', description: 'Doctor of Humane Letters' }],
  [87, { id: 87, code: 'Litt.M.', description: 'Master of Letters' }],
  [19, { id: 19, code: 'LL.B.', description: 'Bachelor of Laws' }],
  [47, { id: 47, code: 'LL.D.', description: 'Doctor of Laws' }],
  [86, { id: 86, code: 'LL.M.', description: 'Master of Laws' }],
  [72, { id: 72, code: 'M.A.', description: 'Master of Arts' }],
  [1029, { id: 1029, code: 'M.A.L.D.', description: 'Masters of Arts in Law and Diplomacy' }],
  [1012, { id: 1012, code: 'M.A.L.S.', description: 'Master of Arts in Liberal Studies' }],
  [73, { id: 73, code: 'M.A.T.', description: 'Master of Arts in Teaching' }],
  [71, { id: 71, code: 'M.Aero.E.', description: 'Master of Aeronautical Engineering' }],
  [1028, { id: 1028, code: 'M.Arch.', description: 'Master of Architecture' }],
  [76, { id: 76, code: 'M.B.A.', description: 'Master of Business Administration' }],
  [77, { id: 77, code: 'M.C.E.', description: 'Master of Christian Education' }],
  [81, { id: 81, code: 'M.C.R.P.', description: 'Master of City and Regional Planning' }],
  [123, { id: 123, code: 'M.C.S.', description: 'Master of Civil Engineering' }],
  [78, { id: 78, code: 'M.C.S.', description: 'Master of Commercial Science' }],
  [50, { id: 50, code: 'M.D.', description: 'Doctor of Medicine' }],
  [79, { id: 79, code: 'M.Div.', description: 'Master of Divinity' }],
  [82, { id: 82, code: 'M.E.', description: 'Master of Engineering' }],
  [1008, { id: 1008, code: 'M.E.M.', description: 'Master of Engineering Management' }],
  [80, { id: 80, code: 'M.Ed.', description: 'Master of Education' }],
  [85, { id: 85, code: 'M.F.', description: 'Master of Forestry' }],
  [84, { id: 84, code: 'M.F.A.', description: 'Master of Fine Arts' }],
  [1017, { id: 1017, code: 'M.G.A.', description: 'Master of Government Administration' }],
  [1024, { id: 1024, code: 'M.H.A.', description: 'Master of Health Care Administration' }],
  [1005, { id: 1005, code: 'M.H.S.', description: 'Master of Health Science' }],
  [98, { id: 98, code: 'M.H.R.', description: 'Master in Human Resources' }],
  [89, { id: 89, code: 'M.J.', description: 'Master of Jurisprudence' }],
  [1007, { id: 1007, code: 'M.L.S.', description: 'Master of Library Science' }],
  [90, { id: 90, code: 'M.L.I.S.', description: 'Master of Library and Information Science' }],
  [92, { id: 92, code: 'M.M.', description: 'Master of Music' }],
  [91, { id: 91, code: 'M.M.E.', description: 'Master of Mechanical Engineering' }],
  [124, { id: 124, code: 'M.M.E.', description: 'Master of Music Education' }],
  [95, { id: 95, code: 'M.Nurs.', description: 'Master of Nursing' }],
  [127, { id: 127, code: 'M.P.A.', description: 'Master of Public Affairs' }],
  [96, { id: 96, code: 'M.P.A.', description: 'Master of Public Administration' }],
  [128, { id: 128, code: 'M.PH', description: 'Master of Public Health' }],
  [125, { id: 125, code: 'M.Phil', description: 'Master of Philosophy' }],
  [126, { id: 126, code: 'M.P.I.A', description: 'Master of Public and International Affairs' }],
  [129, { id: 129, code: 'M.P.P.', description: 'Master of Public Policy' }],
  [1021, { id: 1021, code: 'M.P.P.A.', description: 'Master of Public Policy and Administration' }],
  [97, { id: 97, code: 'M.R.E.', description: 'Master of Religious Education' }],
  [1000, { id: 1000, code: 'M.R.P.', description: 'Masters of Regional Planning' }],
  [101, { id: 101, code: 'M.S.', description: 'Master of Science' }],
  [102, { id: 102, code: 'M.S.E.', description: 'Masters of Science in Engineering' }],
  [94, { id: 94, code: 'M.S.M.', description: 'Masters of Material Science Metallurgy' }],
  [88, { id: 88, code: 'M.S.N.', description: 'Masters of Science in Nursing' }],
  [103, { id: 103, code: 'M.S.W.', description: 'Master of Social Work' }],
  [99, { id: 99, code: 'M.T.S.', description: 'Masters in [Christian] Theological Studies' }],
  [104, { id: 104, code: 'M.Th.', description: 'Master of Theology' }],
  [106, { id: 106, code: 'Nuc.E.', description: 'Nuclear Engineer' }],
  [51, { id: 51, code: 'O.D.', description: 'Doctor of Optometry' }],
  [54, { id: 54, code: 'Ph.D.', description: 'Doctor of Philosophy' }],
  [53, { id: 53, code: 'Pharm.D.', description: 'Doctor of Pharmacy' }],
  [1013, { id: 1013, code: 'Psy. D.', description: 'Doctor of Psychology' }],
  [1018, { id: 1018, code: 'Sc.D.', description: 'Doctor of Science' }],
  [45, { id: 45, code: 'S.J.D.', description: 'Doctor of Juridical Science' }],
  [120, { id: 120, code: 'S.J.D.', description: 'Doctor of the Science of Law' }],
  [61, { id: 61, code: 'S.Sc.D.', description: 'Doctor of Social Science' }],
  [29, { id: 29, code: 'S.T.B.', description: 'Bachelor of Sacred Theology' }],
  [58, { id: 58, code: 'S.T.D.', description: 'Doctor of Sacred Theology' }],
  [100, { id: 100, code: 'S.T.M.', description: 'Master of Sacred Theology' }],
  [36, { id: 36, code: 'Th.B.', description: 'Bachelor of Theology' }],
  [64, { id: 64, code: 'Th.D.', description: 'Doctor of Theology' }]
])

export const DegreeSelect: React.FC<{ value: Degree | null, updateDegree: (degree: Degree | null) => void, disabled: boolean }> = ({ value, updateDegree, disabled }) => {
  const handleChange = (value: string | number): void => {
    const selectedOption = degreeOptions.get(value as number)
    updateDegree(selectedOption ?? null)
  }

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel id="degree-select-label">Degree</InputLabel>
      <Select
        labelId="degree-select-label"
        label="Degree"
        value={(value != null) ? value.id : ''}
        onChange={(event) => { handleChange(event.target.value) }}
        disabled={disabled}
        fullWidth
      >
        {Array.from(degreeOptions.values()).map((degree) => (
          <MenuItem key={degree.id} value={degree.id}>
            {degree.description}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
